import * as types from "../../constants/actionTypes";
import moment from "moment";

const initState = {
  isLoading: false,
  masterData: [],
  cariPasien: {
    findByCode: "",
    isExist: 0,
  },
  listDokterAktif: [],
  formReservasi: {
    f_id_reservasi: "",
    f_tgl_reservasi: moment().format("YYYY-MM-DD HH:mm:ss"),
    f_status_reservasi: "",
    f_create_on: moment().format("YYYY-MM-DD"),
    f_catatan: "",
    f_id_klinik: "",
    f_id_poli: "",
    f_id_dokter: "",
    f_id_pasien: "",
  },
  formDataPasien: [],
};

export default function (state = initState, action) {
  switch (action.type) {
    case types.MODULE_RESERVASI_SET_LOADER: {
      return {
        ...state,
        isLoading: action.value,
      };
    }
    case types.MODULE_RESERVASI_INIT_FORM_CARI_PASIEN: {
      return {
        ...state,
        cariPasien: {
          ...initState.cariPasien,
        },
      };
    }
    case types.MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI_RESET: {
      return {
        ...state,
        formReservasi: state.formReservasi,
      };
    }
    case types.MODULE_RESERVASI_INIT_FORM_RESERVASI: {
      return {
        ...state,
        formReservasi: {
          ...initState.formReservasi,
        },
      };
    }
    case types.MODULE_RESERVASI_HANDLE_STATE_CARI_PASIEN: {
      return {
        ...state,
        cariPasien: {
          ...state.cariPasien,
          [action.property]: action.value,
        },
      };
    }
    case types.MODULE_RESERVASI_HANDLE_STATE_RESERVASI: {
      return {
        ...state,
        formReservasi: {
          ...state.formReservasi,
          [action.property]: action.value,
        },
      };
    }
    case types.MODULE_RESERVASI_MASTER_DATA_SUCCESS: {
      return {
        ...state,
        masterData: {
          ...state.masterData,
          [action.property]: action.value,
        },
      };
    }
    case types.MODULE_RESERVASI_VALIDATE_CODE_SUCCESS: {
      return {
        ...state,
        formDataPasien: {
          ...action.payload,
        },
      };
    }
    case types.MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI_SUCCESS: {
      return {
        ...state,
        listDokterAktif: [...action.payload],
      };
    }

    default:
      return {
        ...state,
      };
  }
}
